var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"report-footer px-5 pb-5"},[_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column is-11 has-text-left"},[_vm._t("default"),_c('url-text',{attrs:{"locale-key":'footer.text'}})],2),_c('div',{staticClass:"column is-1 has-text-right"},[_vm._v(_vm._s(_vm.pageNumber || ''))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }